import { useCallback } from "react"
import { useAISync } from "../providers/AISyncProvider"

export type AiCommentEntityType =
  | "pre_order"
  | "pre_order_flow"
  | "whatsapp_chat"
  | "email"
  | "sms_chat"

export function useAiCommentMutations() {
  const { engine } = useAISync()

  const removeComment = useCallback(
    async (
      entityType: AiCommentEntityType,
      entityId: string,
      commentId: string
    ): Promise<void> => {
      await engine.http.delete<{ removed: true }>(
        `/api/v2/ai-comments/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}/${encodeURIComponent(commentId)}`
      )
    },
    [engine]
  )

  return { removeComment }
}
